export const TOGGLE_LOADING = 'TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'TOGGLE_SUCCESS'
export const CREATE_ATTACHMENT = 'CREATE_ATTACHMENT'
export const EDIT_ATTACHMENT = 'EDIT_ATTACHMENT'
export const DELETE_ATTACHMENT = 'DELETE_ATTACHMENT'
export const SET_ATTACHMENTS = 'SET_ATTACHMENTS'
export const SET_ATTACHMENT = 'SET_ATTACHMENT'
export const SET_EDIT_ATTACHMENT = 'SET_EDIT_ATTACHMENT'
export const SET_DELETE_ATTACHMENT = 'SET_DELETE_ATTACHMENT'
